import styled from '@emotion/styled/macro';
import { Variables } from '../variables';

const V = Variables.ThemeLight;

export type BannerTone = 'info' | 'warning' | 'danger' | 'neutral';

/**
 * Pale surface, dark foreground from the same family, one step darker for the border.
 *
 * Never a `*Mild*` surface with `*Medium*` text: both are surface ramps and the pair is about
 * 1.2:1, unreadable by construction (NS-2).
 */
const TONES: Record<BannerTone, { background: string; border: string; foreground: string }> = {
    info: { background: V.PrimaryMild2, border: V.PrimaryMild1, foreground: V.PrimaryInverted3 },
    warning: { background: V.AttentionMild3, border: V.AttentionMild1, foreground: V.AttentionInverted3 },
    danger: { background: V.WarningMild3, border: V.WarningMild1, foreground: V.WarningInverted3 },
    neutral: { background: V.Background1, border: V.Border1, foreground: V.TextMedium },
};

export const Banner = styled.div<{ tone: BannerTone }>`
    display: flex;
    align-items: flex-start;
    gap: 10px;
    padding: 10px 14px;
    border-radius: 8px;
    border: 1px solid ${({ tone }) => TONES[tone].border};
    background: ${({ tone }) => TONES[tone].background};
    color: ${({ tone }) => TONES[tone].foreground};
    font-size: 13px;
    line-height: 1.45;
`;

export const IconSlot = styled.span`
    display: inline-flex;
    flex: none;
    margin-top: 1px;
`;

export const Content = styled.div`
    flex: 1 1 auto;
    min-width: 0;
`;

export const Title = styled.div`
    font-weight: 600;
`;

export const Body = styled.div`
    margin-top: 2px;
`;

export const Action = styled.div`
    display: flex;
    flex: none;
    align-items: center;
    align-self: center;
`;
